<script setup>
import GuestLayout from "@/Layouts/GuestLayout.vue";

defineOptions({ layout: GuestLayout });
</script>

<template>
    Coming Soon
</template>

<style scoped>

</style>
